import React from 'react';
import QRCode from 'react-qr-code';

interface QRCodeDisplayProps {
  value: string;
  size?: number;
  title?: string;
  className?: string;
  onClick?: () => void;
  compact?: boolean;
}

const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({ 
  value, 
  size = 100, 
  title = 'Scan to request a song:',
  className = '',
  onClick
  , compact = false
}) => {
  if (!value) return null;

  return (
    <div 
      className={`fixed right-6 bottom-6 z-40 bg-white rounded-xl border-2 border-qr-primary shadow-lg ${compact ? 'p-2' : 'p-3'} text-center cursor-pointer hover:shadow-xl transition-shadow ${className}`}
      onClick={onClick}
      title={compact ? 'Tap to open search' : 'Click to open song request/search panel'}
    >
      {!compact && <p className="m-0 text-sm text-qr-dark mb-2">{title}</p>}
      <div className={`${compact ? '' : 'bg-white p-2'}`}>
        <QRCode value={value} size={size} />
      </div>
      {!compact && (
        <>
          <div className="text-xs mt-1 text-gray-600 max-w-[120px] truncate">{value}</div>
          <div className="text-xs text-qr-primary mt-1">Tap or click to open search</div>
        </>
      )}
      {compact && (
        <div className="text-[11px] text-qr-primary mt-1">Tap to open search</div>
      )}
    </div>
  );
};

export default QRCodeDisplay;